//index.js
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import cartReducer from "./cart_reducer";
import getCustomers from "./customers_reducers";
import productsReducer from "./product_reducer";
import getOrders from "./order_reducer";
import discountReducer from "./discount_reducer";
import inventoryReducer from "./inventory_reducer";
import analyticsReducer from "./analytics_reducer";
import usersReducer from "./users_reducer";
import globalReducer from "./global_reducer";
import companyInfoReducer from "./companyinfo_reducer";
import vendorsReducer from "./vendor_reducer";
import individualsReducer from "./individual_reducer";
import organizationsReducer from "./organizations_reducer";
import purchaseOrderReducer from "./purchaseorder_reducer";
import purchaseStockReducer from "./purchaseStock_reducer";
import purchaseRequestsReducer from "./purchaseRequests_reducer";
import rfqsReducer from "./rfqs_reducer";
import vendorQuotationsReducer from "./vendorQuotations_reducer";
import accountsPayableReducer from "./accountsPayable_reducer";
import printerSettingInfoReducer from "./printersetting_reducer";
import purchasedAppReducer from "./purchasedapp_reducer";
import zatcaInfoReducer from "./zatcainfo_reducer";
import authReducer from "./authReducer";
import realmUserReducer from "./realmuser_reducer";
import { quotationsReducer } from "./quotationsReducer";
import { deliveryReducer } from "./deliveryReducer";
import { invoiceReducer } from "./invoiceReducer";
import moduleConfigReducer from "./moduleConfig_reducer";
import hposTillReducer from "./hposTill_reducer";
import authzReducer from "./authz_reducer";
import { getPersistStorageItemKey } from "../../utilities/appSessionKey";

const appReducer = combineReducers({
  cart: cartReducer,
  customersState: getCustomers,
  productsState: productsReducer,
  ordersState: getOrders,
  discountState: discountReducer,
  inventoryState: inventoryReducer,
  analyticsState: analyticsReducer,
  usersState: usersReducer,
  globalState: globalReducer,
  companyInfoState: companyInfoReducer,
  vendorsState: vendorsReducer,
  individualsState: individualsReducer,
  organizationsState: organizationsReducer,
  purchaseOrderState: purchaseOrderReducer,
  purchaseStockState: purchaseStockReducer,
  purchaseRequestsState: purchaseRequestsReducer,
  rfqsState: rfqsReducer,
  vendorQuotationsState: vendorQuotationsReducer,
  accountsPayableState: accountsPayableReducer,
  printerSettingState: printerSettingInfoReducer,
  purchasedAppState: purchasedAppReducer,
  zatcaMetaState: zatcaInfoReducer,
  authReducer: authReducer,
  realmUserState: realmUserReducer,
  quotationsState: quotationsReducer,
  deliveriesState: deliveryReducer,
  invoicesState: invoiceReducer,
  moduleConfigState: moduleConfigReducer,
  hposTillState: hposTillReducer,
  authzState: authzReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "USER_LOGOUT") {
    // Clear only this tab's app/instance persist bucket (not other apps' sessions).
    try {
      storage.removeItem(getPersistStorageItemKey());
    } catch (_) {
      /* ignore */
    }
    // Legacy unscoped key from before tenant-scoped persist
    try {
      storage.removeItem("persist:root");
    } catch (_) {
      /* ignore */
    }
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

// Persist is applied once in store.js (avoid nested persist with empty whitelist).
export default rootReducer;
